import React from "react";
import { Card, Col, Row, Statistic, Spin, List, Typography, Tag } from "antd";
import { ExclamationCircleOutlined, UserOutlined, TeamOutlined } from "@ant-design/icons";
import { useAuth } from "../../contexts/auth.context";
import { UserRole } from "../../types/user.type";
import { MissingPositionsStats as MissingPositionsStatsType } from "../../types/position.type";

interface MissingPositionsStatsProps {
  data: MissingPositionsStatsType | null;
  loading: boolean;
}

export default function MissingPositionsStats({ data, loading }: MissingPositionsStatsProps) {
  
  if (loading) {
    return <Spin size="large" />;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const positionsWithIssues = data.positions.filter(pos => pos.hasMissingWorkers);

  return (
    <div style={{ padding: "20px" }}>
        <>
          <h2>Статистика должностей</h2>

          <Row gutter={16}>
            <Col span={8}>
              <Card>
                <Statistic
                  title="Всего сотрудников"
                  value={data.totalAssignedWorkers}
                  prefix={<TeamOutlined />}
                />
              </Card>
            </Col>
            <Col span={8}>
              <Card>
                <Statistic
                  title="Должности с недостающими работниками"
                  value={data.positionsWithMissingWorkers}
                  valueStyle={{ color: data.positionsWithMissingWorkers > 0 ? '#cf1322' : '#3f8600' }}
                  prefix={<ExclamationCircleOutlined />}
                />
              </Card>
            </Col>
            <Col span={8}>
              <Card>
                <Statistic
                  title="Всего недостающих работников"
                  value={data.totalMissingWorkers}
                  valueStyle={{ color: data.totalMissingWorkers > 0 ? '#cf1322' : '#3f8600' }}
                  prefix={<UserOutlined />}
                />
              </Card>
            </Col>
          </Row>
        </>
      {positionsWithIssues.length > 0 && (
        <>
          <h3>Должности с недостающими работниками:</h3>
          <div style={{ marginTop: "20px", maxHeight: "300px", overflowY: "auto" }}>
            <List
              dataSource={positionsWithIssues}
              renderItem={(item) => (
                <List.Item>
                  <Card style={{ width: "100%", background: "#fff2f0", border: "1px solid #ffccc7" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div>
                        <Typography.Text strong style={{ fontSize: "16px" }}>
                          {item.positionName}
                        </Typography.Text>
                        <div style={{ marginTop: "8px" }}>
                          <Tag color="blue">Требуется: {item.requiredWorkersCount}</Tag>
                          <Tag color="green">Назначено: {item.totalAssignedWorkers}</Tag>
                          <Tag color="red">Не хватает: {item.totalMissingWorkers}</Tag>
                        </div>
                      </div>
                    </div>
                  </Card>
                </List.Item>
              )}
            />
          </div>
        </>
      )}

      {positionsWithIssues.length === 0 && data.totalPositions > 0 && (
        <div style={{ marginTop: "20px" }}>
          <Card style={{ background: "#f6ffed", border: "1px solid #b7eb8f" }}>
            <Typography.Text strong style={{ color: "#52c41a" }}>
              Все должности укомплектованы! 🎉
            </Typography.Text>
          </Card>
        </div>
      )}
    </div>
  );
} 